import { render, staticRenderFns } from "./AllowedReturn.vue?vue&type=template&id=158a9548&scoped=true"
import script from "./AllowedReturn.vue?vue&type=script&lang=js"
export * from "./AllowedReturn.vue?vue&type=script&lang=js"
import style0 from "./AllowedReturn.vue?vue&type=style&index=0&id=158a9548&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158a9548",
  null
  
)

export default component.exports